import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import axiosBackEnd from "../../config/axios/axios-back-end";
import _ from "lodash";

import { Collapse, message } from "antd";

import FormOne from "../../components/AppConfig/UserAppConfigManager/FormOne";
import FormTwo from "../../components/AppConfig/UserAppConfigManager/FormTwo";

const { Panel } = Collapse;

class UserAppConfigManager extends Component {
  state = {
    dataOne: null,
    applicationsMapByAppName: null,
  };

  formTwoFormRef = React.createRef();

  async componentDidMount() {
    await this.props.userListGet();

    if (!this.props.api.applicationsGetData) {
      await this.props.applicationsGet();
    }
    if (
      this.props.api.applicationsGetData &&
      this.props.api.applicationsGetData.data
    ) {
      const applicationsMapByAppName = _.keyBy(
        this.props.api.applicationsGetData.data,
        "app_name"
      );
      this.setState({ applicationsMapByAppName: applicationsMapByAppName });
    }
  }

  getDataOne = async (data) => {
    this.props.apiStart();
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const response = await axiosBackEnd.get("/api/users/app-config", {
        params: data,
        headers: headers,
      });
      // const response = await axiosBackEnd.post("/api/user/app-config", data, { headers: headers });
      // console.log(response, "response");
      if (response && response.data && response.data.data) {
        this.setState({ dataOne: response.data.data });
      }
      this.formTwoFormRef.current.resetFields();
      const fieldsValues = {};
      const appConfigDataOne =
        response &&
        response.data &&
        response.data.data &&
        response.data.data.role &&
        response.data.data.role.app_config_data
          ? response.data.data.role.app_config_data
          : [];
      const appConfigDataTwo =
        response &&
        response.data &&
        response.data.data &&
        response.data.data.app_config_data
          ? response.data.data.app_config_data
          : [];
      const merge = _.merge(
        _.keyBy(appConfigDataOne, "app_id"),
        _.keyBy(appConfigDataTwo, "app_id")
      );
      if (merge) {
        for (const [k, a] of Object.entries(merge)) {
          if (k) {
            fieldsValues[k] = {};
            if (a.config) {
              for (const [kk, aa] of Object.entries(a.config)) {
                fieldsValues[k][kk] = aa;
              }
            }
          }
        }
      }

      this.formTwoFormRef.current.setFieldsValue(fieldsValues);
      this.props.apiComplete();
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
      } else {
        message.error(err.message);
      }
      this.props.apiComplete();
      console.log("Eroor: ", err);
    }
  };

  userIdOnChange = async (value) => {
    if (value) {
      this.getDataOne({ user_id: value });
    } else {
      this.setState({ dataOne: null });
    }
  };
  formOneOnFinish = async (data) => {
    if (data.user_id) {
      this.getDataOne({ user_id: data.user_id });
    } else {
      this.setState({ dataOne: null });
    }
  };

  formTwoOnFinish = async (data) => {
    const send_data = {};
    send_data._id =
      this.state.dataOne && this.state.dataOne._id
        ? this.state.dataOne._id
        : null;
    send_data.app_config_data = data;
    this.props.apiStart();
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      // const response = await axiosBackEnd.get("/api/users/app-config", { params: data, headers: headers });
      const response = await axiosBackEnd.post(
        "/api/users/app-config-update",
        send_data,
        { headers: headers }
      );
      if (response.data) {
        message.success(response.data.message);
      } else {
        console.log("Eroor: ", response);
      }
      this.props.apiComplete();
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
      } else {
        message.error(err.message);
      }
      this.props.apiComplete();
      console.log("Eroor: ", err);
    }
  };

  render() {
    return (
      <div>
        <div className="container_ab">
          <div className="container_style_2">
            <Collapse defaultActiveKey={["1_1"]} expandIconPosition="end">
              <Panel header="User App Config" key="1_1" arrow="right">
                <div className="is_form_1">
                  {this.props.api.userListGetData ? (
                    <FormOne
                      // wrappedComponentRef={this.formOneSaveFormRef}
                      // onSubmit={this.formOneSubmit}
                      // foremOneUserNameOnChange={this.foremOneUserNameOnChange}
                      userListGetData={this.props.api.userListGetData.data}
                      userIdOnChange={this.userIdOnChange}
                      formOneOnFinish={this.formOneOnFinish}
                    />
                  ) : null}
                </div>
              </Panel>
            </Collapse>

            <div style={{ marginBottom: 20 }}></div>

            {this.state.dataOne ? (
              <FormTwo
                formTwoOnFinish={this.formTwoOnFinish}
                formRef={this.formTwoFormRef}
                applicationsMapByAppName={this.state.applicationsMapByAppName}
                dataOne={this.state.dataOne}
              />
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

// const WrappedApp = Form.create({ name: "coordinated" })(RoleManager);

const mapStateToProps = (state) => {
  return {
    api: state.api,
  };
};

const mapDispatchToProps = (dispatch) => ({
  userListGet: () => dispatch(actions.userListGet()),
  applicationsGet: () => dispatch(actions.applicationsGet()),

  apiStart: (data) => dispatch(actions.apiStart(data)),
  apiComplete: (data) => dispatch(actions.apiComplete(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserAppConfigManager);
